const isProduction = process.env.NODE_ENV === 'production';
const cache = {};
export function deprecate(message, condition) {
  if (!isProduction && !cache[message] && condition) {
    cache[message] = true;
    console.warn(`VCC UI Deprecation: ${message}`);
  }
}